<template lang="pug">
div.mobile-wrapper(:style="mainMenuStyle")
  div.nav-menu.mobile
    slot(name="menu")
      div(
        v-for="menus, index in localItems"
        :key="index"
      )
        hr.nav-menu__divider(
          v-if="index !== 0"
          :style="sectionMenuStyle"
        )
        main-nav(
          :items="menus"
          :max-level="menuMaxLevel"
        )
  div(class="nav-search mobile")
    slot(name="search")
      main-search(
        :target="searchTarget"
        :field-name="searchName"
        :field-value="searchValue"
        @submit="onSubmit"
      )
</template>

<script>
import MainSearch from '@/components/parts/form/Search.vue';
import MainNav from '@/components/parts/nav/Mobile.vue';
import checkMobile from '@/mixins/checkMobile';
import colorMainMenu from '@/mixins/colorMainMenu';
import colorSectionMenu from '@/mixins/colorSectionMenu';

export default {
  mixins: [checkMobile, colorMainMenu, colorSectionMenu],

  components: {
    MainSearch,
    MainNav,
  },

  props: {
    collapsedTitle: {
      type: String,
      default: 'Каталог',
    },

    menuItems: {
      type: Array,
      required: true,
    },

    searchTarget: {
      type: [Object, String],
      default: '',
    },

    searchName: {
      type: String,
      default: null,
    },

    searchValue: {
      type: String,
      default: '',
    },

    menuMaxLevel: {
      type: Number,
      default: 2,
    },
  },

  computed: {
    localItems() {
      return this.searchIsFocused
        ? [{ text: this.collapsedTitle }]
        : this.menuItems;
    },
  },

  methods: {
    onSubmit(data) {
      this.$emit('submitSearch', data);
    },
  },
};
</script>

<style lang="stylus">
@import '../../../stylus/helpers/mediaqueriesStep'

.mobile-wrapper
  display block
  padding 20px
  background #5a58ad
  min-height 100%
  max-height 100vh
  overflow auto

.nav-menu.mobile
  box-sizing border-box
  position relative
  display none
  .nav-menu__divider
    height 2px
    border none
    background #5a58ad
    margin-top 8px

  +phone()
    display inline-block
    width 100%
    padding 0

.nav-search.mobile
  position relative
  display none

  +phone()
    display inline-block
    width 100%
    padding 0
    margin 20px 0 0
</style>



// WEBPACK FOOTER //
// NavMobile.vue?8a448ca4